import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import * as Sentry from "@sentry/react";
import { CaptureConsole } from "@sentry/integrations";
import { Integrations } from "@sentry/tracing";
import { pruneExpiredDrafts } from "./lib/inspectionDraftStore";
import { startSessionBeacon } from "./lib/sessionContinuity";

const stage = `${process.env.REACT_APP_STAGE}`;

if (`${process.env.NODE_ENV}` === "production") {
  Sentry.init({
    dsn: "https://8134e707ccaa4df9b43850301b907e46@o93944.ingest.sentry.io/5226296",
    release: process.env.REACT_APP_SENTRY_RELEASE,
    environment: stage,
    integrations: [
      new CaptureConsole({
        levels: ["error"],
      }),
      new Integrations.BrowserTracing(),
    ],
    maxBreadcrumbs: 50,
    attachStacktrace: true,
    tracesSampleRate: 0,
  });
}

// Drop inspection drafts past their TTL so an abandoned report doesn't sit on a
// technician's device indefinitely.
pruneExpiredDrafts();

/*
 * Report the previous session if it died without shutting down cleanly, then
 * start beating for this one. Started here, before render, so a crash during the
 * very first paint is still caught.
 */
startSessionBeacon();

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById("root")
);
